export const apiConfig = {
  REACT_APP_ENV: process.env.REACT_APP_ENV,
  BASE_API_URL: process.env.REACT_APP_API_URL,
  QUANT_BASE_API_URL: process.env.REACT_APP_API_QUANT_URL,
  TV_CHART_DATA_FEED: process.env.REACT_APP_API_UDF_CHART_URL
};
